import React from 'react'
import styled from 'styled-components'
import Banner from '../../components/Banner'
import Title from '../../components/Title'
import Button from '../../components/Button'
import Hr from '../../components/Hr'
import Paragraph from '../../components/Paragraph'
import img1 from '../../assets/static/solutions_img1.png'
import img2 from '../../assets/static/solutions_img2.jpg'
// import img3 from '../../assets/static/solutions_img3.jpg'
// import img4 from '../../assets/static/solutions_img4.png'
import img5 from '../../assets/static/solutions_img5.jpeg'
import img6 from '../../assets/static/solutions_img6.png'
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
  
const About = () => {
  const { t } = useTranslation()
  return (
    <Main>
      <Banner title={t('solutions.hero.title')}>
        <>
          <Hr color="primary" />
          <Title size="small" color="white">
            {t('solutions.hero.desc')}
          </Title>
        </>
      </Banner>
      <Article1>
        <div>
          <Img src={img1} alt="" />
        </div>
        <Content>
          <Title size="mid" color="white">
             {t('solutions.items.0.title')}
          </Title>
          <Paragraph color="white">
            {t('solutions.items.0.desc')}
          </Paragraph>
          <Paragraph />
          <Link to="/contact">
            <Button color="transparent">{t('solutions.items.0.cta')}</Button>
          </Link>
        </Content>
      </Article1>
      <Article1>
        <Content>
          <Title size="mid" color="white">
            {t('solutions.items.1.title')}
          </Title>
          <Paragraph color="white">
            {t('solutions.items.1.desc')}
          </Paragraph>
          <Paragraph />
          <Link to="/contact">
            <Button color="transparent">{t('solutions.items.1.cta')}</Button>
          </Link>
        </Content>
        <div>
          <Img src={img2} alt="" />
        </div>
      </Article1>
     {/*  <Article1>
        <div>
          <Img src={img3} alt="" />
        </div>
        <Content>
          <Title size="mid" color="white">
            {t('solutions.items.2.title')}
          </Title>
          <Paragraph color="white">
            {t('solutions.items.2.desc')}
          </Paragraph>
          <Paragraph />
          <Link to="/contact">
            <Button color="transparent">{t('solutions.items.2.cta')}</Button>
          </Link>
        </Content>
      </Article1>
      <Article1>
        <Content>
          <Title size="mid" color="white">
            {t('solutions.items.3.title')}
          </Title>
          <Paragraph color="white">
            {t('solutions.items.3.desc')}
          </Paragraph>
          <Paragraph />
          <Link to="/contact">
            <Button color="transparent">{t('solutions.items.3.cta')}</Button>
          </Link>
        </Content>
        <div>
          <Img src={img4} alt="" />
        </div>
      </Article1> */}
      <Article1>
        <div>
          <Img src={img5} alt="" />
        </div>
        <Content>
          <Title size="mid" color="white">
            {t('solutions.items.4.title')}
          </Title>
          <Paragraph color="white">
            {t('solutions.items.4.desc')}
          </Paragraph>
          <Paragraph />
          <Link to="/contact">
            <Button color="transparent">{t('solutions.items.4.cta')}</Button>
          </Link>
        </Content>
      </Article1>
      <Article3>
        <Content2>
          <Float src={img6} alt="" />
          <Box>
            <Title size="small" color="white">
              {t('solutions.banner.title')}
            </Title>
            <Link to="/products">
              <Button>
                {t('solutions.banner.cta')}
              </Button>
            </Link>
          </Box>
        </Content2>
        <Content2>
          <Box>
            <Title size="mid" color="secondary">
              {t('solutions.bannerTwo.title')}
            </Title>
            <Title size="small" color="black">
              {t('solutions.bannerTwo.desc')}
            </Title>
            <Link to="/contact">
              <Button>{t('solutions.bannerTwo.cta')}</Button>
            </Link>
          </Box>
        </Content2>
      </Article3>
    </Main>
  )
}

export default About

const Main = styled.main`
  background-color: #fff;
`

const Article1 = styled.article`
  display: grid;
  grid-template-columns: 1fr 1fr;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

const Content = styled.div`
  background-color: #47657e;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 75px;
`

const Content2 = styled.div`
  background-color: #FAFAFA;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`

const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const Article3 = styled.article`
  grid-column: 1/4;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  @media (max-width: 768px) {
    flex-direction: column;
  }
  & > div {
    width: 100%;
    position: relative;
    @media (max-width: 768px) {
      align-items: center;
      box-sizing: border-box;
      padding: 20px;
    }
  }
  & > div:nth-child(1) {
    background-color: ${({ theme }) => theme.bgWeb};
    display: flex;
    align-items: flex-end;
    padding: 80px 0;
    @media (max-width: 768px) {
      align-items: center;
      box-sizing: border-box;
      padding: 20px;
    }
  }
`

const Box = styled.div`
  width: 450px;
  margin: 0 25px;
  text-align: center;
  @media (max-width: 768px) {
    width: 100%;
  }
`

const Float = styled.img`
  position: absolute;
  top: 0px;
  left: 0;
  height: 300px;
  @media (max-width: 768px) {
    display: none;
  }
`
